import cx from 'classnames';
import Image from 'next/image';

type TBreadcrumbImageAdornmentProps = {
  rounded?: 'sm' | 'full';
  src: string;
  alt: string;
  width?: number;
  height?: number;
};

export const BreadcrumbImageAdornment = ({
  rounded,
  src,
  alt,
  width = 32,
  height = 32,
}: TBreadcrumbImageAdornmentProps) => (
  <div style={{ width: '16px', height: '16px' }}>
    <Image
      className={cx('object-cover w-[100%] h-[100%]', {
        'rounded-full': rounded === 'full',
        'rounded-sm': rounded === 'sm',
      })}
      alt={alt}
      width={width}
      height={height}
      src={src}
    />
  </div>
);
